import ClubLeaderboard from "@/profile/ClubLeaderboard.tsx";
import Header from "@/Header.tsx";
import {createFileRoute, useParams} from '@tanstack/react-router'
import React from "react";

export const Route = createFileRoute('/_app/clubs/$club_uid/leaderboard')({
    component: RouteComponent,
})

function RouteComponent() {
    const params = useParams({strict: false});
    return (
        <div className="bg-[#0a0e1a] min-h-screen">
            <Header />
            <div className="max-w-6xl mx-auto px-3 sm:px-4 py-6">
                <ClubLeaderboard clubUid={params.club_uid!} />
            </div>
        </div>
    );
}
